import styled, { css } from 'styled-components/macro';

export const Button = styled.button<{
  rightIconStateFill?: string;
  margin?: string;
  padding?: string;
  borderColor?: string;
  borderRadius?: string;
  backgroundColor?: string;
  disableClick?: boolean;
  additionalBtnStyle?: any;
}>`
  display: flex;
  align-items: center;
  padding: ${({ padding, theme }) =>
    padding ? padding : `${theme.spacing.zero_1} ${theme.spacing.zero_2}`};
  border: ${({ theme, borderColor }) =>
    `1px solid ${borderColor ? borderColor : theme.colors.black_20}`};
  border-radius: ${({ theme, borderRadius }) =>
    `${borderRadius ? borderRadius : theme.spacing.zero_1}`};

  ${({ additionalBtnStyle }) => additionalBtnStyle && additionalBtnStyle};

  ${({ theme, margin }) =>
    margin
      ? `margin: ${margin};`
      : `margin-right: ${theme.spacing.zero_2};
margin-bottom: ${theme.spacing.zero_2};`}

  color: ${({ theme }) => theme.colors.black_80};
  font-size: ${({ theme }) => theme.fontSize.xxs};

  background-color: ${({ backgroundColor }) =>
    `${backgroundColor ? backgroundColor : 'transparent'}`};

  :focus {
    outline: 2px solid ${({ theme }) => theme.colors.primary_dark};
  }

  @supports selector(:focus-visible) {
    :focus {
      outline: none;
    }
    :focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.primary_dark};
    }
  }

  ${({ disableClick, theme, rightIconStateFill }) =>
    disableClick
      ? `:hover {
        background-color: none;
      } cursor: pointer;`
      : `:hover {
    background-color: ${theme.colors.black_5};
  } cursor: pointer;
  :active {
    color: ${theme.colors.primary_dark};
    background-color: ${theme.colors.black_5};

    strong {
      font-weight: ${theme.fontWeight.semiBold};
    }

    svg {
      fill: ${rightIconStateFill};
    }
  }
  `}
`;

export const Label = styled.strong<{ labelPadding?: string; fontSize?: string }>`
  padding: ${({ labelPadding, theme }) =>
    labelPadding ? labelPadding : `0 ${theme.spacing.zero_2}`};
  font-size: ${({ fontSize, theme }) => (fontSize ? fontSize : theme.fontSize.xxs)};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

const buttonTypeStyle = (btnTypeValue: string, margin?: string, padding?: string) => {
  switch (btnTypeValue) {
    case 'rounded':
      return css`
        border-radius: 2.75rem;
        margin: ${margin ? margin : '0 0.5rem 1rem 0'};
        padding: ${padding ? padding : '0.5rem 0.75rem'};
      `;

    case 'cube':
      return css`
        border-radius: 0.25rem;
        margin: ${margin ? margin : '0 0.5rem 0 0'};
        padding: ${padding ? padding : '0.25rem 0.5rem'};
      `;

    default:
      break;
  }
};

export const PriceListButton = styled.button<{
  isActive?: boolean;
  btnType: string;
  margin?: string;
  backgroundColor?: string;
  border?: string;
  padding?: string;
  width?: string;
  height?: string;
}>`
  background-color: ${({ isActive, theme, backgroundColor }) =>
    isActive ? theme.colors.primary : backgroundColor ? backgroundColor : theme.colors.white};
  border: ${({ border, isActive, theme }) =>
    border ? border : '1px solid' + (isActive ? theme.colors.primary : theme.colors.black_20)};

  ${({ btnType, margin, padding }) => buttonTypeStyle(btnType, margin, padding)}

  ${({ width }) => width && `width: ${width}`};
  ${({ height }) => height && `height: ${height}`};

  cursor: pointer;
`;

export const ChipsWrapper = styled.div<{ marginMobile?: string; overflow?: string }>`
  position: relative;
  overflow: ${({ overflow }) => (overflow ? overflow : 'scroll')};
  white-space: nowrap;
  scrollbar-width: none;

  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: ${({ marginMobile }) => (marginMobile ? marginMobile : '3rem 0 0 0')};
  }
`;
